import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'
import { Button, Text } from 'shared/components'

import { FormContext } from '../../context'

import * as styles from './styles'

const FormButtonComponent = ({
  id,
  submit,
  type,
  children,
  behaviour,
  long,
  ...props
}) => {
  const form = useContext(FormContext)
  const { submission } = form

  // Support both type prop and legacy submit prop
  const buttonType = type || (submit ? 'submit' : 'button')

  return (
    <Button
      type={buttonType}
      id={id || `${form.id}-${buttonType}`}
      disabled={
        (behaviour === 'invalid-disabled' && form.isInvalid) || submission
      }
      loading={submission || false}
      {...props}
    >
      <Text css={submission && styles.submission}>{children}</Text>
    </Button>
  )
}

FormButtonComponent.propTypes = {
  id: PropTypes.string,
  children: PropTypes.node.isRequired,
  behaviour: PropTypes.string,
  long: PropTypes.bool,
  submit: PropTypes.bool,
  type: PropTypes.string,
}

export default observer(FormButtonComponent)
